let global = {
  imgUrl: process.env.IMG_URL
}

export default global


// WEBPACK FOOTER //
// ./src/common/js/global.js